import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { Times } from '@styled-icons/fa-solid/Times';
import { Copy } from '@styled-icons/fa-solid/Copy';
import { toast } from 'react-toastify';
import {
  ModalWrapper,
  ModalContent,
  ModernTitle,
  ModernSubtitle,
  ModernButtonSecondary,
} from './shared/ModalBase';
import { ButtonContainer } from './shared/FormComponents';

const CloseButton = styled(Times)`
  cursor: pointer;
  position: absolute;
  width: 2rem;
  height: 2rem;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  color: var(--clr-sec);
  opacity: 0.7;
  z-index: 10;

  &:hover {
    color: #ff6b6b;
    opacity: 1;
    transform: scale(1.1);
  }
`;


const ContactSection = styled.div`
  margin: 1.5rem 0;
`;

const ContactMethod = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 12px;
  padding: 1rem;
  margin: 0.75rem 0;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  width: 100%;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CopyIcon = styled(Copy)`
  width: 1.2rem;
  height: 1.2rem;
  color: white;
`;

const DiscordLink = styled.a`
  display: block;
  background: #5865F2;
  border: none;
  border-radius: 12px;
  padding: 1rem;
  margin: 0.75rem 0;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(88, 101, 242, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(88, 101, 242, 0.4);
    background: #4752C4;
  }

  &:active {
    transform: translateY(0);
  }
`;


const FeedbackModal = (props) => {
  function onClose() {
    const analytics = getAnalytics();
    logEvent(analytics, 'feedback_modal_closed');
    props.onClose();
  }

  const copyToClipboard = async (text, type) => {
    try {
      await navigator.clipboard.writeText(text);
      const analytics = getAnalytics();
      logEvent(analytics, 'contact_copied', {
        type: type,
        referrer: 'feedback_modal',
      });
      toast.success('Copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy text: ', err);
      toast.error('Failed to copy');
    }
  };

  const handleDiscordJoin = () => {
    const analytics = getAnalytics();
    logEvent(analytics, 'discord_clicked', {
      referrer: 'feedback_modal',
    });
  };

  return (
    <Modal
      isOpen={props.visible}
      onRequestClose={onClose}
      style={{
        overlay: { 
          zIndex: 1000, 
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          backdropFilter: 'blur(4px)',
        },
        content: {
          background: 'none',
          border: 'none',
          padding: 0,
          inset: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
      ariaHideApp={false}
    >
      <ModalWrapper>
        <ModalContent>
          <CloseButton onClick={onClose} />
          
          <ModernTitle>Feedback & Bug Reports</ModernTitle>
          <ModernSubtitle>
            Found a bug or have suggestions for VentScape? I'd love to hear from you!
          </ModernSubtitle>
          
          <ContactSection>
            <ContactMethod onClick={() => copyToClipboard('gabetheventscapedev', 'discord')}>
              <span>Discord: gabetheventscapedev</span>
              <CopyIcon />
            </ContactMethod>
            
            <ContactMethod onClick={() => copyToClipboard('gabe@ventscape.life', 'email')}>
              <span>Email: gabe@ventscape.life</span>
              <CopyIcon />
            </ContactMethod>
            
            <DiscordLink 
              href="https://discord.gg/rM7g5Zusmr"
              target="_blank"
              rel="noreferrer noopener"
              onClick={handleDiscordJoin}
            >
              Join VentScape Discord
            </DiscordLink>
          </ContactSection>
          
          <ButtonContainer>
            <ModernButtonSecondary onClick={onClose}>
              Close
            </ModernButtonSecondary>
          </ButtonContainer>
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};

export default FeedbackModal;